import { render, staticRenderFns } from "./SupportToken.vue?vue&type=template&id=59f5c8fa&"
import script from "./SupportToken.vue?vue&type=script&lang=js&"
export * from "./SupportToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f5c8fa')) {
      api.createRecord('59f5c8fa', component.options)
    } else {
      api.reload('59f5c8fa', component.options)
    }
    module.hot.accept("./SupportToken.vue?vue&type=template&id=59f5c8fa&", function () {
      api.rerender('59f5c8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/SupportToken.vue"
export default component.exports